import cn from 'classnames';
import { HTMLAttributes } from 'react';
import { CardHeader } from '@/shared/ui/core';
import styles from './auth-card.module.scss';


export function AuthCardHeader ({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
    return (
        <CardHeader
            className={ cn(styles.header, className) }
            data-template="auth-card-header"
            { ...props }
        />
    );
}
